import React, { useEffect } from 'react'
import Header from './Header'
import Navbar from './Navbar'
import Footer from './Footer'
import aos from 'aos'
import HeroSection from './HeroSection'
import { Link, useLocation, useNavigate } from 'react-router-dom'

const JobDescription = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Get job data from location state, or use default data if none was passed
  const jobData = location.state?.jobData 

  useEffect(() => {
    aos.init({
      duration: 1000,
      once: true,
      easing: 'ease-out'
    });
    window.scrollTo(0, 0);
  }, []);

  // Handler functions
  const handleBackToJobs = () => {
    navigate('/form', { state: { role: jobData.title } });
  };

  const handleApply = ( jobTitle) => {
    // Create email parameters
    const email = jobData.contactEmail;
    const subject = `Application for ${jobTitle}`;
    const body = `Dear Hiring Team,

I am writing to express my interest in the ${jobTitle} position advertised on your website.

I believe my skills and experience align well with the requirements for this role. I have attached my resume and cover letter for your review.

Thank you for considering my application. I look forward to the opportunity to discuss how my background, skills and experience would be beneficial to your organization.

Best regards,
[Your Name]`;

    // Encode the subject and body for the mailto URL
    const encodedSubject = encodeURIComponent(subject);
    const encodedBody = encodeURIComponent(body);
    
    // Create the mailto URL
    const mailtoLink = `mailto:${email}?subject=${encodedSubject}`;
    
    // Open the mail client
    window.location.href = mailtoLink;
    
    console.log(`Opening email client for job: ${jobTitle}`);
  };

  const handleDownloadPDF = () => {
    if (jobData && jobData.pdf_path) {
      // Replace backslashes with forward slashes
      const fullPath = `https://kristellar.com/${jobData.pdf_path.replace(/\\/g, '/')}`;
      window.open(fullPath, '_blank');
      console.log(`Opening PDF: ${fullPath}`);
    } else {
      console.error("PDF path not found");
    }
  };
  
  
  return (
    <div>
        <Header />
        <Navbar />

        <HeroSection 
        title="Career Details" 
        breadcrumb={
          <>
            <Link to={"/careers"}>Careers</Link> 
          </>
        } 
      />

        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8 my-10"
        data-aos="fade-up">
          {/* <button 
            onClick={handleBackToJobs} 
            className="text-blue-600 mb-6 flex items-center hover:text-blue-800 transition-colors"
          >
            <span className="mr-2">←</span> Back to Careers
          </button> */}
          
          <h2 className="text-3xl font-bold text-gray-800 mb-4">{jobData.title}</h2>
          
          <div className="mb-8 flex flex-wrap gap-2">
            {/* <span className="inline-block bg-blue-100 text-blue-800 text-md px-3 py-1 rounded-full font-medium">
              {jobData.department}
            </span> */}
            <span className="inline-block bg-blue-100 text-blue-800 text-md px-3 py-1 rounded-full font-medium">
              {jobData.location}
            </span>
            <span className="inline-block bg-blue-100 text-blue-800 text-md px-3 py-1 rounded-full font-medium">
              {jobData.type}
            </span>
          </div>
          
          <div className="prose max-w-none mb-8">
            <h3 className="text-2xl font-semibold mb-3 text-gray-700">About the Role</h3>
            <p className="text-lg mb-6 text-gray-600 leading-relaxed">{jobData.description}</p>
            
            <h3 className="text-2xl font-semibold mb-3 text-gray-700">Responsibilities</h3>
            <ul className="list-disc pl-6 mb-6 space-y-2 text-gray-600 text-lg">
              {jobData.responsibilities.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            
            <h3 className="text-2xl font-semibold mb-3 text-gray-700">Requirements</h3>
            <ul className="list-disc pl-6 mb-6 space-y-2 text-gray-600 text-lg">
              {jobData.requirements.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>

            <h3 className="text-2xl font-semibold mb-3 text-gray-700">Vacancy: {jobData.vacancy}</h3>
            {/* <ul className="list-disc pl-6 mb-6 space-y-2 text-gray-600 text-lg">
              {jobData.vacancy}
            </ul> */}
          </div>
          
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <button 
              // onClick={() => handleApply( jobData.title)} 
              onClick={handleBackToJobs} 
              className="bg-blue-600 text-white py-3 px-6 rounded-md hover:bg-blue-700 transition-colors font-medium flex-1 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
            >
              Apply Now
            </button>
            <button 
              onClick={handleDownloadPDF} 
              className="bg-gray-200 text-gray-800 py-3 px-6 rounded-md hover:bg-gray-300 transition-colors font-medium flex-1 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-50"
            >
              Download Detailed JD (PDF)
            </button>
          </div>
        </div>
        <Footer />
    </div>
  )
}

export default JobDescription